/** Path segment after `/shop/` (e.g. `all`, `gifts`). Base paths are `/shop/${segment}`. */
export const ALLOWED_SURFACE_SEGMENTS = ['all', 'gifts'] as const;

export const TAXONOMY_PLP_CONTENT_TYPE = 'taxonomy_plp';

export const STACK_NAME = 'DX' as const;

export const PAGE_SIZE = 250;

export const MAX_PAGES = 2;

export const LARGE_NEIGHBORHOOD_WARN_COUNT = 500;

export const CACHE_TTL_SECONDS = 3600;

export const CACHE_KEY_PREFIX = 'taxonomy_plp_map:shop';

export const TAXONOMY_PLP_LIST_TIMEOUT_MS = 1000;

export const TAXONOMY_PLP_ONLY_FIELDS = [
  { field: 'url', refUid: 'BASE' },
  { field: 'seo.indexable', refUid: 'BASE' },
] as const;
